import { createContext, useContext } from "react";

import type { CustomMailSettingTestMailInput } from "@/lib/gql/__generated__/graphql";

import type { ProductDayTripPlanI18nFormModel } from "../../model/type";

type QueryData = ProductDayTripPlanI18nFormModel["QueryData"];
type ViewModel = ProductDayTripPlanI18nFormModel["ViewModel"];

export type ProductDayTripPlanI18nFormModelContextType = {
	viewModel: ViewModel;
	onSetViewModel: <K extends keyof ViewModel>(values: { key: K; value: ViewModel[K] }[]) => void;

	queryData: QueryData;

	testEmailSender: {
		sendTestMailAtReservationCreate: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtReservationUpdate: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtReservationCancel: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore07Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore01Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore00Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckOutAfter01Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
	};
};

export const ProductDayTripPlanI18nFormModelContext = createContext<ProductDayTripPlanI18nFormModelContextType | null>(
	null,
);

export const useProductDayTripPlanI18nFormModelContext = () => {
	const context = useContext(ProductDayTripPlanI18nFormModelContext);

	if (!context) {
		throw new Error(
			"useProductDayTripPlanI18nFormModelContext must be used within a ProductDayTripPlanI18nFormModelContext.Provider",
		);
	}

	return context;
};
